import { Component } from 'js-component-framework';
import { AriaPopup } from 'js-component-framework/lib/plugins';
import { disqusUtils } from 'utils/disqus';
import DOMPurify from 'dompurify';

export default class DisqusToggle extends Component {
  /**
   * Constructor. Binds function scope.
   * @param {object} props - Props for this component.
   */
  constructor(config) {
    super(config);
    this.createPopup = this.createPopup.bind(this);
    this.onClick = this.onClick.bind(this);
    this.resetDisqus = this.resetDisqus.bind(this);
    this.init();
  }

  /**
   * Fire when toggle is clicked
   */
  onClick(event) {
    this.currentURL = this.element.getAttribute('data-url');
    this.currentIdentifier = this.element.getAttribute('data-identifier');
    this.currentTitle = this.element.getAttribute('data-title');

    // Stop if there's no data-url set on the trigger.
    if ('' === this.currentURL) {
      console.log('Please set an anchor for this trigger.'); // eslint-disable-line no-console
      return;
    }

    const disqusThread = document.getElementById('disqus_thread');

    if (
      this.currentURL !== DOMPurify.sanitize(window.location.href) // phpcs:ignore WordPressVIPMinimum.JS.Window.location
      && disqusThread
    ) {
      // Thoroughly destroy existing Disqus instances.
      while (disqusThread.hasChildNodes()) {
        disqusThread.firstChild.remove();
      }
      disqusThread.remove();
    }

    // Push the new url to the address bar and window history.
    window.history.pushState(null, null, this.currentURL);

    // Reset Disqus and create the popup
    this.createPopup(this.currentURL);
    this.resetDisqus(
      this.currentURL,
      this.currentIdentifier,
      this.currentTitle
    );

    // If the popup exists already, toggle it.
    if (this.popup) this.popup.ariaToggle(event);
  }

  resetDisqus(url, identifier, title) {
    disqusUtils.setGlobalConfig(url, identifier, title);

    // reset disqus.
    if (window && window.DISQUS) {
      window.DISQUS.reset({
        reload: true,
        config: () => {
          this.page.identifier = identifier;
          this.page.url = url;
          this.page.title = title;
        },
      });
    }
  }

  /**
   * Create #disqus_thread and add popup ux.
   */
  createPopup() {
    const {
      children: {
        controller,
      },
      options: {
        ariapopup: attributes,
      },
    } = this;

    // Does the #disqus_thread element exist already?
    // If not, create it and hook it into an AriaPopup.
    const existingElem = this.element.querySelector('#disqus_thread');

    if (! existingElem) {
      // Create and append new #disqus_thread DOM node to component element.
      const target = document.createElement('div');
      target.setAttribute('id', 'disqus_thread');
      this.element.appendChild(target);

      // Create and show a new popup instance.
      this.popup = new AriaPopup({
        controller,
        target,
        attributes,
      });
    }
  }

  /**
   * Renders component markup.
   */
  init() {
    // Bail if there's no element.
    if (! this.element) return;

    const {
      controller,
    } = this.children;

    if (! controller) return;

    document.addEventListener('keydown', (e) => {
      if ('27' === e.keyCode && this.popup) {
        this.popup.ariaHide();
      }
    });

    controller.addEventListener(
      'click',
      (e) => this.onClick(e)
    );
  }
}
